<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            Students
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search Name"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :loading="!teacher"
            loading-text="Loading... Please wait"
            :headers="headers"
            :items="teacher.examRegistrations"
            :search="search"
            :expanded.sync="expanded"
            show-expand
          >

            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                Fees Paid? {{ item.isPaid ? "Yes" : "No" }}
                <br />
                Theoretical Exam Location: {{ item.theoryLocation }}
                <br />
                Practical Exam Location: {{ item.practicalLocation }}
                <br />
                Oral Exam Location: {{ item.oralLocation }}

              <template v-if="isAdmin || (!isAdmin && item.isFinal && canShowFinalGrades(item.schoolYearId))">
                <br />
                Final Marks: {{ item.totalMark }} 
                <br />
                Practical: {{ item.totalPracticalOralMark }} 
                <br />
                Theory: {{ item.totalTheoreticalMark }}
              </template>                
              </td>
            </template>

            <template v-slot:item.student.childFirstName="{ item }">
              <v-avatar :color="item.student.color" size="36">
                <span class="white--text">
                  <strong>{{ item.student.chipInitials }}</strong>
                </span>
              </v-avatar>
              <strong>&nbsp;&nbsp;{{ item.student.childFirstName }}</strong>
            </template>

            <template v-slot:item.student.childLastName="{ item }">
              <strong>{{ item.student.childLastName }}</strong>
            </template>

            <template v-slot:item.subjectId="{ item }">{{ getSubjectDescription(item.subjectId) }}</template>

            <template v-slot:item.createdDate="{ item }">{{ item.createdDate | formatDate }}</template>

            <template v-slot:item.examGradeType="{ item }">
              <v-chip
                v-if="(item.isFinal && canShowFinalGrades(item.schoolYearId))"
                :color="item.isFinal ? 'primary' : 'secondary'"
              >{{ examGradeType[item.examGradeType] }}</v-chip>

            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import { errorMessageMixin, subjectMixin, examGradeTypeMixin } from "../shared";

export default {
  name: "Teacher",
  mixins: [errorMessageMixin, subjectMixin, examGradeTypeMixin],
  computed: {
    ...mapState(["teacher", "examGradeType", "schoolYears"]),
    ...mapGetters(["isAdmin"])
  },

  async created() {
    await this.loadTeacher();
    await this.loadSubjects();
    if (!this.schoolYears || this.schoolYears.length === 0) {
      await this.loadSchoolYears();
    }
  },
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Child First Name",
          value: "student.childFirstName",
          align: "start"
        },
        {
          text: "Child Last Name",
          value: "student.childLastName"
        },
        {
          text: "Subject",
          value: "subjectId"
        },
        {
          text: "Grade Level",
          value: "gradeLevel"
        },
        {
          text: "Created Date",
          value: "createdDate"
        },
        {
          text: "Exam Grade",
          value: "examGradeType"
        },
        { text: "", value: "data-table-expand" }
      ],
      expanded: []
      
    };
  },
  methods: {
    ...mapActions(["getTeacherAction", "getSchoolYearsAction", "getSubjectsAction", "logout"]),
    async loadTeacher() {
      try {
        await this.getTeacherAction({
          id: this.$store.state.user.id,
          token: this.$store.state.token
        });
        if (this.$store.state.teacher == null) {
          this.logout();
          console.log("im logged out");
          this.$router.go();
        }
      } catch (err) {
        this.$store.state.error = this.errorMessage(err);
        this.$store.state.snackbar = true;
        console.log(err);
      }
    },
    async loadSchoolYears() {
      try {
        await this.getSchoolYearsAction();
        if (this.$store.state.schoolYears == null) {
          this.logout();
          console.log("im logged out");
          this.$router.go();
        }
      } catch (err) {
        this.$store.state.error = this.errorMessage(err);
        this.$store.state.snackbar = true;
        console.log(err);
      }
    },
    async loadSubjects() {
      await this.getSubjectsAction();
    },
    canShowFinalGrades(schoolYearId) {
      const today = this.dateToString(new Date());
      if (!this.schoolYears) {
        return false;
      }
      const schoolYear = this.schoolYears.find(s => s.id === schoolYearId);
      if (!schoolYear) {
        return false;
      }

      return today > schoolYear.finalGradeReleaseDate;
    }
  }
};
</script>
